module.exports = __webpack_public_path__ + "img/header.5cde7915.png";